module.exports = __webpack_public_path__ + "themes/fq/img/background.jpg";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/background.jpg
// module id = 55
// module chunks = d-game